import { render, staticRenderFns } from "./MovementRouteLessonDetail.vue?vue&type=template&id=c2fd33b6"
import script from "./MovementRouteLessonDetail.vue?vue&type=script&lang=js"
export * from "./MovementRouteLessonDetail.vue?vue&type=script&lang=js"
import style0 from "./MovementRouteLessonDetail.vue?vue&type=style&index=0&id=c2fd33b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports